module.exports = __webpack_public_path__ + "static/media/Dragon-Idle.87c7390a.gif";